import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Icon, Row } from "../../../components/Component";
import { getDashboardData } from '../../../redux/admin/dashboard/action'
import RecentLimitzoOrders from './recentOrders';
import { Button, Card } from 'reactstrap';
import SalesStatisticsLimitzo from './salesStatistics';
import TodayUsers from './todayUsers';
import RecentStores from './recentStores';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import CountUp from 'react-countup';
import { ColorRing } from 'react-loader-spinner';


const AdminDashboard = () => {

    const dispatch = useDispatch();
    useEffect(() => {
        const formatedStart = moment(startDate).format('DD-MM-yyyy');
        const formatedEnd = moment(endDate).format('DD-MM-yyyy');
        dispatch(getDashboardData(formatedStart, formatedEnd)).then((response) => {
            if (response.payload.success) {
                setLoading(false)
            }
        })
    }, []);

    const getSelectors = (state) => ({
        recent_orders: state.dashboard.recent_orders,
        today_users: state.dashboard.today_users,
        recent_stores: state.dashboard.recent_stores,
        total_stores: state.dashboard.total_stores,
        sales_count: state.dashboard.sales_count,
        sales_earning: state.dashboard.sales_earning,
        users_count: state.dashboard.users_count,
        weekly_orders: state.dashboard.weekly_orders,
    });

    const { recent_orders, today_users, recent_stores, total_stores, sales_earning, sales_count, users_count, weekly_orders } = useSelector(getSelectors);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [loading, setLoading] = useState(true);

    const handleDatePicker = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    }

    const filterDashBoardData = () => {
        const formatedStart = moment(startDate).format('DD-MM-yyyy');
        const formatedEnd = moment(endDate).format('DD-MM-yyyy');
        dispatch(getDashboardData(formatedStart, formatedEnd));
    }

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Dashboard"></Head>
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle className={"user-select-none"} page tag="h3">
                                        Dashboard
                                    </BlockTitle>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle user-select-none">
                                        <div className="toggle-expand-content">
                                            <ul className="nk-block-tools g-3">
                                                <li>
                                                    <ReactDatePicker
                                                        selected={startDate}
                                                        onChange={handleDatePicker}
                                                        startDate={startDate}
                                                        endDate={endDate}
                                                        selectsRange
                                                        dateFormat="dd-MM-yy"
                                                        className="form-control date-picker"
                                                    />
                                                </li>
                                            </ul>
                                            <ul className="nk-block-tools g-3">
                                                <li className='ml-1'>
                                                    <Button className='btn-dim' size='sm' onClick={() => { filterDashBoardData() }} ><Icon name='filter' /></Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>

                        <Block>
                            <Row className="g-gs user-select-none">
                                {/* count */}
                                <Col xxl="4">
                                    <Row className="g-gs">
                                        {/* users */}
                                        <Col xxl="12" md="3">
                                            <Card>
                                                <div className="nk-ecwg nk-ecwg3 pb-3 user-select-none">
                                                    <div className="card-inner pb-0">
                                                        <div className="card-title-group">
                                                            <div className="card-title">
                                                                <h6 className="title">Users</h6>
                                                            </div>
                                                        </div>
                                                        <div className="data">
                                                            <div className="data-group">
                                                                <div className="amount">
                                                                    <CountUp start={0} end={users_count} duration={2.5} delay={1} />
                                                                </div>
                                                                <div className="info text-right">
                                                                    <span className="change up text-danger" style={{ fontSize: '20px' }}>
                                                                        <Icon name="user-list"></Icon>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                        {/* sales */}
                                        <Col xxl="12" md="4">
                                            <Card>
                                                <div className="nk-ecwg nk-ecwg3 pb-3 user-select-none">
                                                    <div className="card-inner pb-0">
                                                        <div className="card-title-group">
                                                            <div className="card-title">
                                                                <h6 className="title">Sales</h6>
                                                            </div>
                                                        </div>
                                                        <div className="data">
                                                            <div className="data-group">
                                                                <div className="amount">₹{" "}<CountUp start={0.00} end={parseFloat(sales_earning)} decimals="2" duration={2.5} delay={1} /> </div>
                                                                <div className="info text-right">
                                                                    <span className="change up text-danger" style={{ fontSize: '20px' }}>
                                                                        <Icon name="wallet"></Icon>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                        {/* orders */}
                                        <Col xxl="6" md="3">
                                            <Card>
                                                <div className="nk-ecwg nk-ecwg3 pb-3">
                                                    <div className="card-inner pb-0">
                                                        <div className="card-title-group">
                                                            <div className="card-title">
                                                                <h6 className="title">Orders</h6>
                                                            </div>
                                                        </div>
                                                        <div className="data">
                                                            <div className="data-group">
                                                                <div className="amount"><CountUp start={0} end={sales_count} duration={2.5} delay={1} /> </div>
                                                                <div className="info text-right">
                                                                    <span className="change up text-danger" style={{ fontSize: '20px' }}>
                                                                        <Icon name="cart"></Icon>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                        {/* stores */}
                                        <Col xxl="6" md="2">
                                            <Card>
                                                <div className="nk-ecwg nk-ecwg3 pb-3">
                                                    <div className="card-inner pb-0">
                                                        <div className="card-title-group">
                                                            <div className="card-title">
                                                                <h6 className="title">Stores</h6>
                                                            </div>
                                                        </div>
                                                        <div className="data">
                                                            <div className="data-group">
                                                                <div className="amount"><CountUp start={0} end={total_stores} duration={2.5} delay={1} /> </div>
                                                                <div className="info text-right">
                                                                    <span className="change up text-danger" style={{ fontSize: '20px' }}>
                                                                        <Icon name="building"></Icon>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl="8">
                                    <SalesStatisticsLimitzo weekly_orders={weekly_orders} />
                                </Col>
                                <Col xxl="6" md="6">
                                    <TodayUsers today_users={today_users} />
                                </Col>
                                <Col xxl="6" md="6">
                                    <RecentStores recent_stores={recent_stores} />
                                </Col>
                                <Col xxl="12">
                                    <RecentLimitzoOrders recent_orders={recent_orders} />
                                </Col>
                            </Row>
                        </Block>
                    </Content>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default AdminDashboard
